// extracted by mini-css-extract-plugin
module.exports = {"container":"_yHNLSr2b","content":"_txMkt1vw","iconContainer":"_ZqyI7mYq","title":"_AHGWWMsb","description":"_ASlPNWX-"};